import React from 'react';

import { StyleSheet } from 'react-native';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { Box, BoxProps, withTypography } from 'components/ui';
import { spacing } from 'styles/constants';

import theme from './theme';

const styles = StyleSheet.create({
  name: {
    margin: 0,
  },
  rewardItemDescriptionWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  rewardItemDescriptionDetail: {
    marginLeft: spacing.$0_5,
    textTransform: 'capitalize',
  },
});

// item picture
export const StyledPicture = Picture.withConfig({
  maxWidth: '100px',
  height: '68px',
});

// item name
export const Name = withTypography({
  variant: 'headerOne',
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: '2xs',
  style: styles.name,
});

// item description
export const StyledDescriptionSanityBlockRenderer = SanityBlockRenderer.withConfig({
  textProps: {
    fontFamily: 'body',
    fontSize: 'sm',
    lineHeight: 14,
  },
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  fill: theme.itemDescriptionDefaultColor,
  width: '18px',
});

export const RewardItemDescriptionWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.rewardItemDescriptionWrapper, style],
  });

export const RewardItemDescriptionDetail = withTypography({
  fontFamily: 'heading',
  fontSize: theme.itemDescriptionFontSize,
  color: theme.itemDescriptionDefaultColor,
  lineHeight: theme.itemDescriptionLineHeight,
  style: styles.rewardItemDescriptionDetail,
});
